module.exports = __webpack_public_path__ + "img/mmu-hackathon.361dab3c.png";